import {
  SET_UNREAD_MESSAGE_COUNT,
} from '../../containers/discussion-list/constants';

export function setUnreadMessageCount(discussionId, unreadMessageCount) {
  return {
    type: SET_UNREAD_MESSAGE_COUNT,
    discussionId,
    unreadMessageCount,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/discussion-card/actions.js
 **/